import axios from 'axios'

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('sts_token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

api.interceptors.response.use(
  (response) => {
    const newToken = response.headers['authorization']
    if (newToken) {
      const token = newToken.split(' ')[1]
      if (token) {
        localStorage.setItem('sts_token', token)
      }
    }
    return response
  },
  (error) => {
    // Optional: Handle errors, like logging out on a 401 Unauthorized
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('sts_token')
      // Optionally redirect to login or handle unauthorized access
    }
    return Promise.reject(error)
  },
)

export default api



// WEBPACK FOOTER //
// ./src/data/axios.js